import { IAM_API_BASE_URL, IAM_TENANT_SLUG } from "../config";

export interface IamLoginResult {
  accessToken: string;
  refreshToken: string;
  user: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
  };
}

interface ApiEnvelope<T> {
  success: boolean;
  data: T;
  message?: string;
}

export async function iamRequest<T>(
  path: string,
  options: { method?: string; body?: unknown; accessToken?: string } = {},
): Promise<T> {
  const method = options.method ?? "GET";
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    Accept: "application/json",
    "X-Tenant-Slug": IAM_TENANT_SLUG,
  };

  if (options.accessToken) {
    headers.Authorization = `Bearer ${options.accessToken}`;
  }

  const response = await fetch(`${IAM_API_BASE_URL}${path}`, {
    method,
    headers,
    body:
      method === "GET" || method === "DELETE"
        ? undefined
        : JSON.stringify(options.body ?? {}),
  });

  const json = (await response.json()) as ApiEnvelope<T>;
  if (!response.ok) {
    throw new Error(json.message ?? `IAM request failed: ${response.status}`);
  }

  if (json && typeof json === "object" && "success" in json && "data" in json) {
    return json.data;
  }

  return json as T;
}
